import SolutionIntegrationsI18n from "@/components/landing/shared/SolutionIntegrationsI18n";
const KundenserviceIntegrationsSection = () => <SolutionIntegrationsI18n translationPrefix="kundenserviceSolution" />;
export default KundenserviceIntegrationsSection;
